<template>
  <el-dialog
    title="扫码加入班级"
    :visible.sync="dialogVisible"
    width="520px"
    center="center"
  >
    <div class="erweima">
      <img :src="qr_code" alt="">
      <div style="color:#2881cd">使用授课通APP扫码加入班级</div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props:{
    qr_code:{
      type:String,
      default:''
    },
  },
    data () {
        return {
             dialogVisible: false
        }
    },
    // props:['dialogVisible'],
    methods:{
         handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      }
    }
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body{
  // text-align: center;
}
/deep/ .el-dialog__title{
  font-weight: bold;
}
.erweima{
  div{
    width: 200px;
    margin: auto;
  }
  img{
    display: block;
    margin: auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/Panel/banji/addClassQr.vue